/* eslint-disable react/jsx-wrap-multilines */
/* eslint-disable react/jsx-one-expression-per-line */
import { useParams } from 'react-router-dom';
import { useTranslate } from 'hooks/useTranslate';

import menuTypes from 'constants/menuTypes';

import Page from 'modules/_shared/components/Pages/Page';
import PageWithTabs from 'modules/_shared/components/Pages/PageWithTabs';
import PageListHeader from 'modules/_shared/components/Headers/PageListHeader';
import GoBackButton from 'modules/_shared/components/Buttons/GoBackButton';
import CustomLoading from 'modules/_shared/components/CustomLoading';
import EmployeeAside from 'modules/beneficiaries/components/EmployeeAside';
import { useGetMenu } from 'modules/administratives/hooks/useGetMenu';
import { useGetActualSociety } from 'hooks/useGetActualSociety';
import PageWithTabsAsideWrapper from 'modules/_shared/components/Pages/PageWithTabs/components/PageWithTabsAsideWrapper';

import { useEmployeeDetail } from './hooks/useEmployeeDetail';

import './EmployeeDetail.scss';

const EmployeeDetail = () => {
  const { t } = useTranslate();
  const { societyId } = useParams();

  const {
    data: { pages, actualEmployee, incorporationDate, employeeIncentiveData },
  } = useEmployeeDetail();

  useGetMenu(menuTypes.EXTENDED);
  useGetActualSociety(societyId);

  return actualEmployee ? (
    <Page id="employee-detail">
      <PageListHeader
        subTitle={t('Employee')}
        subTitleSuffix={actualEmployee?.fullName}
        description={`${t('Since')}: ${incorporationDate || '-'}`}
        actions={[<GoBackButton key="go-back-button" />]}
      />

      <PageWithTabs
        tabs={[
          {
            key: 'employee-tab',
            icon: 'ni-user-circle',
            title: t('Employee'),
            content: pages[0],
          },
          {
            key: 'data-tab',
            icon: 'ni-list',
            title: t('Data'),
            content: pages[1],
          },
          {
            key: 'historic-tab',
            icon: 'ni-histroy',
            title: t('Historic'),
            content: pages[2],
          },
        ]}
        asideContent={
          <PageWithTabsAsideWrapper>
            <EmployeeAside
              employee={actualEmployee}
              incentiveData={employeeIncentiveData}
            />
          </PageWithTabsAsideWrapper>
        }
        isError={false}
        isLoading={false}
      />
    </Page>
  ) : (
    <CustomLoading />
  );
};

export default EmployeeDetail;
